<template>
  <!-- 设置新密码 -->
  <div class="box">
    <div class="content">
      <img class="reg-img" src="../../views/retrievePassword/assets/images/Forget password_shezhixinmima.png" alt="">
      <!--表单开始 -->
      <el-form :model="fromData" ref="fromData" label-width="100px" class="demo-ruleForm" :rules="rules">
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input type="password" v-model.trim="fromData.password" placeholder="请输入6-18位数字或字母组合"></el-input>
        </el-form-item>
        <!-- 确认密码 -->
        <el-form-item prop="confirmPassword">
          <el-input type="password" v-model.trim="fromData.confirmPassword" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <!-- 按钮 -->
        <el-form-item>
          <!-- <el-button type="primary" class="btn-left" @click="handleBack">上一步</el-button> -->
          <el-button type="primary" class="btn-right" @click="handleRegister">确认</el-button>
        </el-form-item>
      </el-form>
      <!-- 表单结束 -->
    </div>
  </div>
</template>

<script>
//引入api
import { forgetPonePassword, forgetEmailPassword } from '@/services/loginRegister';
// 引入md5
import md5 from "js-md5";
export default {
  name: "setNewPassword",
  props: {
    // 控制显示
    stepActive: {
      type: Number,
      required: true
    },
    userTest: {
      type: String,
      required: true
    },
    info: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    // 密码验证
    const testPassword = (rule, value, callback) => {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      if (value === "") {
        callback(new Error("请输入密码"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入6-18位数字或字母组合"))
      } else {
        callback()
      }
    }
    // 确认密码验证
    const testConfirmPassword = (rule, value, callback) => {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入6-18位数字或字母组合"))
      } else if (this.fromData.password !== value) {
        callback(new Error("两次输入密码不一致"))
      } else {
        callback()
      }
    }
    return {
      // 表单数据
      fromData: {
        password: "",
        confirmPassword: ""
      },
      // 验证规则
      rules: {
        password: [{ validator: testPassword, trigger: 'blur' },],
        confirmPassword: [{ validator: testConfirmPassword, trigger: 'blur' }]
      },
      // 设置显示
      activeNum: this.stepActive,
    }
  },
  mounted() {
    // console.log(this.info, '----------------*');
    // console.log(this.userTest, "---------------*");
  },
  methods: {
    // 返回上一页
    handleBack() {
      this.$emit('setStepActive', --this.activeNum)
    },
    // 注册
    handleRegister() {
      this.$refs.fromData.validate(async (valid) => {
        if (valid) {
          if (this.userTest === 'userPone') {//手机号码重置密码、
            // 接口参数
            const params = {
              loginPhone: this.info.loginPhone,
              password: md5(this.fromData.confirmPassword),
              verificationCode: this.info.VerifyCode,
            }
            // 调用手机号码重置密码接口
            const { success } = await forgetPonePassword(params)
            success && this.$emit('setStepActive', ++this.activeNum)
          } else { // 邮箱重置密码
            // 接口参数
            const params = {
              email: this.info.loginPhone,
              password: md5(this.fromData.confirmPassword),
              verificationCode: this.info.VerifyCode,
            }
            // 调用邮箱重置密码接口
            const { success } = await forgetEmailPassword(params)
            success && this.$emit('setStepActive', ++this.activeNum)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../views/registration/assets/images/register_bg3.png")
    no-repeat;
  .content {
    box-sizing: border-box;
    padding: 0 75px;
    position: absolute;
    top: 127px;
    left: 0px;
    width: 460px;
    height: 400px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
    .reg-img {
      margin-top: 69px;
      width: 177px;
      height: 41px;
    }
    /deep/.el-form {
      margin-top: 37px;
      .el-form-item__content {
        margin-left: 0 !important;
        .el-input__inner {
          height: 46px;
          &::placeholder {
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            opacity: 0.5;
            text-align: center;
          }
        }
      }
      .btn-left {
        width: 140px;
        height: 46px;
        font-size: 16px;
        color: #0078fc;
        background: #ffffff;
        border: 1px solid #0078fc;
        border-radius: 8px;
      }
      .btn-right {
        // width: 140px;
        width: 100%;
        font-size: 16px;
        height: 46px;
        border-radius: 8px;
        background-color: #0078fc;
        &:hover {
          background: #3393fd;
          border-color: #3393fd;
        }
        &:active {
          background: #006ce3;
          border-color: #006ce3;
        }
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>